export const translations = {
  en: {
    // Navbar
    nav: {
      home: 'Home',
      freeHoroscope: 'Free Horoscope',
      zodiacSigns: 'Zodiac Signs',
      matchMaking: 'Match Making',
      festivals: 'Festivals',
      hinduFestivals: 'Hindu Festivals',
      tamilFestivals: 'Tamil Festivals',
      teluguFestivals: 'Telugu Festivals',
      importantDates: 'Important Dates',
      blog: 'Blog',
      contact: 'Contact',
      language: 'EN',
    },

    // Footer
    footer: {
      description: 'Your trusted destination for authentic Vedic astrology. Discover your cosmic destiny with our expert astrologers and personalized horoscope readings.',
      quickLinks: 'Quick Links',
      freeHoroscopeEn: 'Free Horoscope (English)',
      freeHoroscopeTa: 'ஜாதகம் (Tamil)',
      dailyHoroscope: 'Daily Horoscope',
      zodiacSigns: 'Zodiac Signs',
      matchMakingEn: 'Match Making (English)',
      matchMakingTa: 'பொருத்தம் (Tamil)',
      subscribe: 'Subscribe to Newsletter',
      emailPlaceholder: 'Enter your email',
      copyright: 'AstroEpanchang. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      refund: 'Refund Policy',
    },

    // Hero Section
    hero: {
      badge: '✨ #1 Trusted Astrology Platform',
      title: 'Discover Your Cosmic Destiny',
      subtitle: 'Unlock the secrets of your birth chart with authentic Vedic astrology. Get personalized predictions, daily horoscopes, and zodiac insights based on ancient Vedic wisdom.',
      happyUsers: 'Happy Users',
      zodiacSignsCount: 'Zodiac Signs',
      horoscopesGenerated: 'Horoscopes Generated',
      formTitle: 'Get Your Free Horoscope',
      formSubtitle: 'Enter your birth details for instant analysis',
      fullName: 'Full Name',
      enterName: 'Enter your name',
      gender: 'Gender',
      select: 'Select',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      birthPlace: 'Birth Place',
      searchCity: 'Search city...',
      birthDate: 'Birth Date',
      birthTime: 'Birth Time',
      language: 'Language',
      english: 'English',
      tamil: 'தமிழ் (Tamil)',
      generateHoroscope: 'Generate My Horoscope',
      dataSecure: '🔒 Your data is secure and private',
      scrollToExplore: 'Scroll to explore',
    },

    // Panchang Hero
    panchang: {
      dailyPanchangam: '🙏 Daily Panchangam',
      todaysPanchang: "Today's Panchang",
      panchangDesc: 'Get accurate daily Hindu calendar with tithi, nakshatra, yoga, and auspicious timings calculated for your city using Vedic astronomy.',
      nakshatras: 'Nakshatras',
      tithis: 'Tithis',
      cities: 'Cities',
      searchCity: 'Search city...',
      city: 'City',
      yourLocation: 'Your Location',
      sunrise: 'Sunrise',
      sunset: 'Sunset',
      tithi: 'Tithi',
      nakshatra: 'Nakshatra',
      yoga: 'Yoga',
      tamilYoga: 'Tamil Yoga',
      rahuKalam: 'Rahu Kalam',
      gulikaiKalam: 'Gulikai Kalam',
      yamaganda: 'Yamaganda',
      abhijitMuhurta: 'Abhijit Muhurta',
      chandrashtama: 'Chandrashtama',
      viewFullPanchangam: 'View Full Panchangam',
      scrollToExplore: 'Scroll to explore',
    },

    // Services Grid
    services: {
      title: 'Our Services',
      subtitle: 'Explore our comprehensive range of astrology services designed to guide you through life\'s journey',
      horoscope: 'Free Horoscope / Birth Chart',
      horoscopeDesc: 'Get your detailed birth chart analysis with planetary positions, dasha periods, and life predictions.',
      dailyHoroscope: 'Daily Horoscope',
      dailyHoroscopeDesc: 'Read your daily, weekly, monthly, and yearly horoscope predictions for all zodiac signs.',
      zodiac: 'Zodiac Signs',
      zodiacDesc: 'Explore detailed characteristics, compatibility, and traits of all 12 zodiac signs.',
      matchMaking: 'Match Making',
      matchMakingDesc: 'Check marriage compatibility and get detailed horoscope matching reports.',
      panchangService: 'Panchang',
      panchangServiceDesc: 'View daily panchang, muhurat timings, and auspicious dates for important events.',
      explore: 'Explore',
    },

    // Why Choose Us
    whyChoose: {
      title: 'Why Choose AstroEpanchang?',
      subtitle: 'Experience the most trusted and comprehensive astrology platform',
      authentic: '100% Authentic',
      authenticDesc: 'All our astrologers are verified experts with years of proven experience in Vedic astrology.',
      astrologers: '500+ Astrologers',
      astrologersDesc: 'Choose from a diverse panel of certified astrologers specializing in various branches.',
      trusted: 'Trusted by Millions',
      trustedDesc: 'Over 2.5 million happy users trust us for their astrological guidance and predictions.',
      availability: '24/7 Availability',
      availabilityDesc: 'Our astrologers are available round the clock for consultations via chat or call.',
      global: 'Global Reach',
      globalDesc: 'Serving users across 50+ countries with accurate timezone-adjusted predictions.',
      confidential: 'Confidential',
      confidentialDesc: 'Your personal information and consultations are completely private and secure.',
    },

    // Testimonials
    testimonials: {
      title: 'What Our Users Say',
      subtitle: 'Thousands of satisfied users trust AstroEpanchang for their astrological guidance',
    },

    // CTA Section
    cta: {
      title: 'Ready to Discover Your Cosmic Path?',
      subtitle: 'Explore authentic Vedic astrology insights — birth charts, daily horoscopes, zodiac compatibility, and auspicious dates for life\'s important moments.',
      freeHoroscope: 'Free Horoscope',
      exploreZodiac: 'Explore Zodiac Signs',
      feature1: 'Accurate Vedic Calculations',
      feature2: 'Daily Updated Horoscopes',
      feature3: 'Comprehensive Birth Charts',
    },

    // Horoscope Preview
    horoscopePreview: {
      title: 'Daily Horoscope',
      subtitle: 'Select your zodiac sign to read today\'s horoscope and cosmic guidance',
      viewAll: 'View All Horoscopes',
    },

    // Horoscope Page
    horoscope: {
      title: 'Daily Horoscope',
      subtitle: 'Select your zodiac sign to read today\'s horoscope and cosmic guidance',
      readHoroscope: 'Read Horoscope →',
    },

    // Horoscope Detail
    horoscopeDetail: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yourDailyHoroscope: 'Your Daily Horoscope',
      yourWeeklyHoroscope: 'Your Weekly Horoscope',
      yourMonthlyHoroscope: 'Your Monthly Horoscope',
      love: 'Love',
      career: 'Career',
      health: 'Health',
      finance: 'Finance',
      luckyNumbers: 'Lucky Numbers',
      luckyDay: 'Lucky Day',
      compatibility: 'Best Compatibility',
      element: 'Element',
      rulingPlanet: 'Ruling Planet',
      quality: 'Quality',
      traits: 'Key Traits',
      exploreSign: 'Explore Sign →',
    },

    // Zodiac Page
    zodiac: {
      title: 'Zodiac',
      titleHighlight: 'Signs',
      subtitle: 'Explore the unique characteristics, traits, and compatibility of all 12 zodiac signs',
      allSigns: 'All Signs',
      fireSigns: 'Fire Signs',
      earthSigns: 'Earth Signs',
      airSigns: 'Air Signs',
      waterSigns: 'Water Signs',
      element: 'Element',
      planet: 'Planet',
      quality: 'Quality',
      luckyDay: 'Lucky Day',
      exploreSign: 'Explore Sign →',
      activeNow: 'Active Now',
      understandingElements: 'Understanding the Elements',
      fireTitle: '🔥 Fire Signs',
      fireDesc: 'Aries, Leo, Sagittarius',
      fireTrait: 'Passionate, Dynamic, Temperamental',
      earthTitle: '🌍 Earth Signs',
      earthDesc: 'Taurus, Virgo, Capricorn',
      earthTrait: 'Grounded, Practical, Reliable',
      airTitle: '💨 Air Signs',
      airDesc: 'Gemini, Libra, Aquarius',
      airTrait: 'Intellectual, Social, Communicative',
      waterTitle: '💧 Water Signs',
      waterDesc: 'Cancer, Scorpio, Pisces',
      waterTrait: 'Emotional, Intuitive, Mysterious',
    },

    // Hindu Festivals
    hinduFestivals: {
      title: 'Hindu Festivals',
      subtitle: 'Complete month-wise calendar of Hindu festivals, vrats, and auspicious dates',
      searchPlaceholder: 'Search festivals...',
      showing: 'Showing',
      festival: 'festival',
      festivals: 'festivals',
      all: 'All',
      major: 'Major',
      ekadashi: 'Ekadashi',
      vrat: 'Vrat',
      purnima: 'Purnima',
      amavasya: 'Amavasya',
      festivalType: 'Festival',
      special: 'Special',
      keyHighlights: 'Key Highlights of',
      hinduNewYear: 'Hindu New Year',
      adhikMaas: 'Adhik Maas',
      diwali: 'Diwali',
      holi: 'Holi',
      noResults: 'No festivals found matching your search.',
    },

    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Have questions? We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.',
      sendMessage: 'Send us a Message',
      thankYou: 'Thank you for your message! We\'ll get back to you soon.',
      fullName: 'Full Name',
      namePlaceholder: 'Your name',
      email: 'Email Address',
      emailPlaceholder: 'your@email.com',
      subject: 'Subject',
      selectTopic: 'Select a topic',
      generalInquiry: 'General Inquiry',
      technicalSupport: 'Technical Support',
      billingIssue: 'Billing Issue',
      feedback: 'Feedback',
      message: 'Message',
      messagePlaceholder: 'How can we help you?',
      send: 'Send Message',
      liveChat: 'Live Chat',
      liveChatDesc: 'Quick response during business hours',
      startChat: 'Start Chat',
      supportHours: 'Support Hours: 24/7 for Premium Members',
      faq: 'Frequently Asked Questions',
    },

    // Cookie Consent
    cookie: {
      title: 'We value your privacy',
      description: 'We use cookies to enhance your browsing experience, analyse site traffic, and personalise content. By clicking Accept All, you consent to our use of cookies.',
      privacyPolicy: 'Privacy Policy',
      hideDetails: 'Hide details',
      cookieDetails: 'Cookie details',
      essential: 'Essential',
      essentialDesc: 'Required for the site to function. Cannot be disabled.',
      alwaysOn: 'Always on',
      analytics: 'Analytics',
      analyticsDesc: 'Help us understand how visitors use the site (Google Analytics).',
      optional: 'Optional',
      advertising: 'Advertising',
      advertisingDesc: 'Used to show relevant ads (Google AdSense).',
      essentialOnly: 'Essential Only',
      acceptAll: 'Accept All',
    },

    // Tamil Festivals
    tamilFestivals: {
      title: 'Tamil Festivals',
      subtitle: 'Complete calendar of Tamil Nadu festivals, vrats, and auspicious dates by Tamil month',
      searchPlaceholder: 'Search Tamil festivals...',
      showing: 'Showing',
      festival: 'festival',
      festivals: 'festivals',
      all: 'All',
      major: 'Major',
      pongal: 'Pongal',
      vrat: 'Vrat',
      pournami: 'Pournami',
      amavasai: 'Amavasai',
      festivalType: 'Festival',
      noResults: 'No festivals found matching your search.',
      keyHighlights: 'Key Tamil Festivals of',
      thaiPongal: 'Thai Pongal',
      tamilNewYear: 'Tamil New Year',
      deepavali: 'Deepavali',
      karthigaiDeepam: 'Karthigai Deepam',
      pongalBanner: 'The grand 4-day Tamil harvest festival begins January 13 with Bhogi and concludes January 16 with Kaanum Pongal. Thai Pongal (January 14) is the main celebration day dedicated to the Sun God (Surya).',
    },

    // Telugu Festivals
    teluguFestivals: {
      title: 'Telugu Festivals',
      subtitle: 'Complete calendar of Andhra Pradesh & Telangana festivals, vrats, and auspicious dates by Telugu month',
      searchPlaceholder: 'Search Telugu festivals...',
      showing: 'Showing',
      festival: 'festival',
      festivals: 'festivals',
      all: 'All',
      major: 'Major',
      ekadashi: 'Ekadashi',
      vrat: 'Vrat',
      purnima: 'Purnima',
      amavasya: 'Amavasya',
      festivalType: 'Festival',
      special: 'Special',
      noResults: 'No festivals found matching your search.',
      keyHighlights: 'Key Telugu Festivals of',
      sankranti: 'Makara Sankranti',
      ugadi: 'Ugadi',
      deepavali: 'Deepavali',
      vinayakaChavithi: 'Vinayaka Chavithi',
      ugadiBanner: 'Telugu New Year marks the beginning of a new Chaitra month. Celebrated with Ugadi Pachadi (six-flavour dish), Panchanga Sravanam, and new beginnings across Andhra Pradesh and Telangana.',
    },

    // Blog
    blog: {
      title: 'Astrology & Panchangam',
      titleHighlight: 'Blog',
      subtitle: 'Explore insights, guides, and cosmic wisdom from our expert Vedic astrologers',
      searchPlaceholder: 'Search articles...',
      allPosts: 'All Posts',
      featured: 'Featured',
      readArticle: 'Read Article',
      readMore: 'Read More →',
      noResults: 'No articles found matching your search.',
      newsletter: 'Stay Updated with Cosmic Insights',
      newsletterDesc: 'Subscribe to our newsletter for the latest astrology articles and predictions',
      subscribe: 'Subscribe',
      emailPlaceholder: 'Enter your email',
    },

    // Common
    common: {
      explore: 'Explore',
      readMore: 'Read More',
      viewAll: 'View All',
      learnMore: 'Learn More',
      submit: 'Submit',
      loading: 'Loading...',
      error: 'Something went wrong',
      noData: 'No data available',
    },

    // Months
    months: {
      January: 'January',
      February: 'February',
      March: 'March',
      April: 'April',
      May: 'May',
      June: 'June',
      July: 'July',
      August: 'August',
      September: 'September',
      October: 'October',
      November: 'November',
      December: 'December',
    },
  },

  ta: {
    // Navbar
    nav: {
      home: 'முகப்பு',
      freeHoroscope: 'இலவச ஜாதகம்',
      zodiacSigns: 'ராசி அறிகுறிகள்',
      matchMaking: 'திருமண பொருத்தம்',
      festivals: 'பண்டிகைகள்',
      hinduFestivals: 'இந்து பண்டிகைகள்',
      tamilFestivals: 'தமிழ் பண்டிகைகள்',
      teluguFestivals: 'தெலுங்கு பண்டிகைகள்',
      importantDates: 'முக்கிய தேதிகள்',
      blog: 'கட்டுரைகள்',
      contact: 'தொடர்பு',
      language: 'த',
    },

    // Footer
    footer: {
      description: 'உங்கள் நம்பகமான வேத ஜோதிட தளம். எங்கள் நிபுணர் ஜோதிடர்கள் மற்றும் தனிப்பயனாக்கப்பட்ட ஜாதக வாசிப்புகளுடன் உங்கள் பிரபஞ்ச விதியைக் கண்டறியுங்கள்.',
      quickLinks: 'விரைவு இணைப்புகள்',
      freeHoroscopeEn: 'Free Horoscope (English)',
      freeHoroscopeTa: 'இலவச ஜாதகம் (தமிழ்)',
      dailyHoroscope: 'தினசரி ராசிபலன்',
      zodiacSigns: 'ராசி அறிகுறிகள்',
      matchMakingEn: 'Match Making (English)',
      matchMakingTa: 'திருமண பொருத்தம் (தமிழ்)',
      subscribe: 'செய்திமடலுக்கு பதிவு செய்யுங்கள்',
      emailPlaceholder: 'உங்கள் மின்னஞ்சலை உள்ளிடவும்',
      copyright: 'AstroEpanchang. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
      privacy: 'தனியுரிமைக் கொள்கை',
      terms: 'சேவை விதிமுறைகள்',
      refund: 'பணத்தைத் திரும்பப்பெறும் கொள்கை',
    },

    // Hero Section
    hero: {
      badge: '✨ #1 நம்பகமான ஜோதிட தளம்',
      title: 'உங்கள் பிரபஞ்ச விதியைக் கண்டறியுங்கள்',
      subtitle: 'உண்மையான வேத ஜோதிடத்துடன் உங்கள் ஜாதகத்தின் ரகசியங்களைத் திறக்கவும். பண்டைய வேத ஞானத்தின் அடிப்படையில் தனிப்பயனாக்கப்பட்ட கணிப்புகள், தினசரி ராசிபலன்கள் மற்றும் ராசி நுண்ணறிவுகளைப் பெறுங்கள்.',
      happyUsers: 'மகிழ்ச்சியான பயனர்கள்',
      zodiacSignsCount: 'ராசி அறிகுறிகள்',
      horoscopesGenerated: 'ஜாதகங்கள் உருவாக்கப்பட்டன',
      formTitle: 'உங்கள் இலவச ஜாதகத்தைப் பெறுங்கள்',
      formSubtitle: 'உடனடி பகுப்பாய்விற்கு உங்கள் பிறப்பு விவரங்களை உள்ளிடவும்',
      fullName: 'முழு பெயர்',
      enterName: 'உங்கள் பெயரை உள்ளிடவும்',
      gender: 'பாலினம்',
      select: 'தேர்வு',
      male: 'ஆண்',
      female: 'பெண்',
      other: 'மற்றவை',
      birthPlace: 'பிறந்த இடம்',
      searchCity: 'நகரத்தைத் தேடுங்கள்...',
      birthDate: 'பிறந்த தேதி',
      birthTime: 'பிறந்த நேரம்',
      language: 'மொழி',
      english: 'English',
      tamil: 'தமிழ்',
      generateHoroscope: 'எனது ஜாதகத்தை உருவாக்கு',
      dataSecure: '🔒 உங்கள் தரவு பாதுகாப்பானது',
      scrollToExplore: 'ஸ்க்ரோல் செய்யுங்கள்',
    },

    // Panchang Hero
    panchang: {
      dailyPanchangam: '🙏 தினசரி பஞ்சாங்கம்',
      todaysPanchang: 'இன்றைய பஞ்சாங்கம்',
      panchangDesc: 'வேத வானியலைப் பயன்படுத்தி உங்கள் நகரத்திற்காகக் கணக்கிடப்பட்ட திதி, நட்சத்திரம், யோகம் மற்றும் சுப நேரங்களுடன் துல்லியமான தினசரி இந்து நாட்காட்டியைப் பெறுங்கள்.',
      nakshatras: 'நட்சத்திரங்கள்',
      tithis: 'திதிகள்',
      cities: 'நகரங்கள்',
      searchCity: 'நகரத்தைத் தேடுங்கள்...',
      city: 'நகரம்',
      yourLocation: 'உங்கள் இருப்பிடம்',
      sunrise: 'சூரிய உதயம்',
      sunset: 'சூரிய அஸ்தமனம்',
      tithi: 'திதி',
      nakshatra: 'நட்சத்திரம்',
      yoga: 'யோகம்',
      tamilYoga: 'தமிழ் யோகம்',
      rahuKalam: 'ராகு காலம்',
      gulikaiKalam: 'குளிகை காலம்',
      yamaganda: 'எமகண்டம்',
      abhijitMuhurta: 'அபிஜித் முகூர்த்தம்',
      chandrashtama: 'சந்திராஷ்டமம்',
      viewFullPanchangam: 'முழு பஞ்சாங்கத்தைக் காண்க',
      scrollToExplore: 'ஸ்க்ரோல் செய்யுங்கள்',
    },

    // Services Grid
    services: {
      title: 'எங்கள் சேவைகள்',
      subtitle: 'வாழ்க்கையின் பயணத்தில் உங்களை வழிநடத்த வடிவமைக்கப்பட்ட எங்கள் விரிவான ஜோதிட சேவைகளை ஆராயுங்கள்',
      horoscope: 'இலவச ஜாதகம் / பிறப்பு விளக்கப்படம்',
      horoscopeDesc: 'கிரக நிலைகள், தசா காலங்கள் மற்றும் வாழ்க்கை கணிப்புகளுடன் உங்கள் விரிவான பிறப்பு விளக்கப்பட பகுப்பாய்வைப் பெறுங்கள்.',
      dailyHoroscope: 'தினசரி ராசிபலன்',
      dailyHoroscopeDesc: 'அனைத்து ராசி அறிகுறிகளுக்கும் உங்கள் தினசரி, வாராந்திர, மாதாந்திர மற்றும் வருடாந்திர ராசிபலன் கணிப்புகளைப் படியுங்கள்.',
      zodiac: 'ராசி அறிகுறிகள்',
      zodiacDesc: 'அனைத்து 12 ராசி அறிகுறிகளின் விரிவான பண்புகள், இணக்கத்தன்மை மற்றும் குணாதிசயங்களை ஆராயுங்கள்.',
      matchMaking: 'திருமண பொருத்தம்',
      matchMakingDesc: 'திருமண இணக்கத்தன்மையைச் சரிபார்த்து விரிவான ஜாதக பொருத்த அறிக்கைகளைப் பெறுங்கள்.',
      panchangService: 'பஞ்சாங்கம்',
      panchangServiceDesc: 'தினசரி பஞ்சாங்கம், முகூர்த்த நேரங்கள் மற்றும் முக்கிய நிகழ்வுகளுக்கான சுபமான தேதிகளைக் காணுங்கள்.',
      explore: 'ஆராயுங்கள்',
    },

    // Why Choose Us
    whyChoose: {
      title: 'ஏன் AstroEpanchang-ஐ தேர்வு செய்ய வேண்டும்?',
      subtitle: 'மிகவும் நம்பகமான மற்றும் விரிவான ஜோதிட தளத்தை அனுபவியுங்கள்',
      authentic: '100% உண்மையானது',
      authenticDesc: 'எங்கள் அனைத்து ஜோதிடர்களும் வேத ஜோதிடத்தில் பல ஆண்டுகள் நிரூபிக்கப்பட்ட அனுபவம் கொண்ட சரிபார்க்கப்பட்ட நிபுணர்கள்.',
      astrologers: '500+ ஜோதிடர்கள்',
      astrologersDesc: 'பல்வேறு கிளைகளில் நிபுணத்துவம் பெற்ற சான்றிதழ் பெற்ற ஜோதிடர்களின் பன்முகக் குழுவிலிருந்து தேர்வு செய்யுங்கள்.',
      trusted: 'கோடிக்கணக்கானோரால் நம்பப்படுகிறது',
      trustedDesc: '2.5 மில்லியனுக்கும் மேற்பட்ட மகிழ்ச்சியான பயனர்கள் தங்கள் ஜோதிட வழிகாட்டுதல் மற்றும் கணிப்புகளுக்காக எங்களை நம்புகிறார்கள்.',
      availability: '24/7 கிடைக்கும்',
      availabilityDesc: 'எங்கள் ஜோதிடர்கள் அரட்டை அல்லது அழைப்பு மூலம் ஆலோசனைகளுக்கு இரவு பகலாக கிடைக்கிறார்கள்.',
      global: 'உலகளாவிய அணுகல்',
      globalDesc: '50+ நாடுகளில் துல்லியமான நேர மண்டல சரிசெய்யப்பட்ட கணிப்புகளுடன் பயனர்களுக்கு சேவை செய்கிறோம்.',
      confidential: 'ரகசியமானது',
      confidentialDesc: 'உங்கள் தனிப்பட்ட தகவல்கள் மற்றும் ஆலோசனைகள் முற்றிலும் தனிப்பட்டவை மற்றும் பாதுகாப்பானவை.',
    },

    // Testimonials
    testimonials: {
      title: 'எங்கள் பயனர்கள் என்ன சொல்கிறார்கள்',
      subtitle: 'ஆயிரக்கணக்கான திருப்தியான பயனர்கள் தங்கள் ஜோதிட வழிகாட்டுதலுக்காக AstroEpanchang-ஐ நம்புகிறார்கள்',
    },

    // CTA Section
    cta: {
      title: 'உங்கள் பிரபஞ்ச பாதையைக் கண்டறிய தயாரா?',
      subtitle: 'உண்மையான வேத ஜோதிட நுண்ணறிவுகளை ஆராயுங்கள் — பிறப்பு விளக்கப்படங்கள், தினசரி ராசிபலன்கள், ராசி இணக்கத்தன்மை மற்றும் வாழ்க்கையின் முக்கிய தருணங்களுக்கான சுப தேதிகள்.',
      freeHoroscope: 'இலவச ஜாதகம்',
      exploreZodiac: 'ராசிகளை ஆராயுங்கள்',
      feature1: 'துல்லியமான வேத கணக்கீடுகள்',
      feature2: 'தினசரி புதுப்பிக்கப்பட்ட ராசிபலன்கள்',
      feature3: 'விரிவான பிறப்பு விளக்கப்படங்கள்',
    },

    // Horoscope Preview
    horoscopePreview: {
      title: 'தினசரி ராசிபலன்',
      subtitle: 'இன்றைய ராசிபலன் மற்றும் பிரபஞ்ச வழிகாட்டுதலைப் படிக்க உங்கள் ராசியைத் தேர்ந்தெடுக்கவும்',
      viewAll: 'அனைத்து ராசிபலன்களையும் காண்க',
    },

    // Horoscope Page
    horoscope: {
      title: 'தினசரி ராசிபலன்',
      subtitle: 'இன்றைய ராசிபலன் மற்றும் பிரபஞ்ச வழிகாட்டுதலைப் படிக்க உங்கள் ராசியைத் தேர்ந்தெடுக்கவும்',
      readHoroscope: 'ராசிபலன் படிக்க →',
    },

    // Horoscope Detail
    horoscopeDetail: {
      daily: 'தினசரி',
      weekly: 'வாராந்திர',
      monthly: 'மாதாந்திர',
      yourDailyHoroscope: 'உங்கள் தினசரி ராசிபலன்',
      yourWeeklyHoroscope: 'உங்கள் வாராந்திர ராசிபலன்',
      yourMonthlyHoroscope: 'உங்கள் மாதாந்திர ராசிபலன்',
      love: 'காதல்',
      career: 'தொழில்',
      health: 'ஆரோக்கியம்',
      finance: 'நிதி',
      luckyNumbers: 'அதிர்ஷ்ட எண்கள்',
      luckyDay: 'அதிர்ஷ்ட நாள்',
      compatibility: 'சிறந்த இணக்கத்தன்மை',
      element: 'தனிமம்',
      rulingPlanet: 'ஆளும் கிரகம்',
      quality: 'தரம்',
      traits: 'முக்கிய குணாதிசயங்கள்',
      exploreSign: 'ராசியை ஆராயுங்கள் →',
    },

    // Zodiac Page
    zodiac: {
      title: 'ராசி',
      titleHighlight: 'அறிகுறிகள்',
      subtitle: 'அனைத்து 12 ராசி அறிகுறிகளின் தனித்துவமான பண்புகள், குணாதிசயங்கள் மற்றும் இணக்கத்தன்மையை ஆராயுங்கள்',
      allSigns: 'அனைத்து ராசிகள்',
      fireSigns: 'நெருப்பு ராசிகள்',
      earthSigns: 'பூமி ராசிகள்',
      airSigns: 'காற்று ராசிகள்',
      waterSigns: 'நீர் ராசிகள்',
      element: 'தனிமம்',
      planet: 'கிரகம்',
      quality: 'தரம்',
      luckyDay: 'அதிர்ஷ்ட நாள்',
      exploreSign: 'ராசியை ஆராயுங்கள் →',
      activeNow: 'இப்போது செயலில்',
      understandingElements: 'தனிமங்களைப் புரிந்துகொள்ளுதல்',
      fireTitle: '🔥 நெருப்பு ராசிகள்',
      fireDesc: 'மேஷம், சிம்மம், தனுசு',
      fireTrait: 'உற்சாகமான, ஆற்றலான, உணர்ச்சிவசப்படும்',
      earthTitle: '🌍 பூமி ராசிகள்',
      earthDesc: 'ரிஷபம், கன்னி, மகரம்',
      earthTrait: 'நிலையான, நடைமுறையான, நம்பகமான',
      airTitle: '💨 காற்று ராசிகள்',
      airDesc: 'மிதுனம், துலாம், கும்பம்',
      airTrait: 'அறிவார்ந்த, சமூகமான, தகவல் தொடர்பு',
      waterTitle: '💧 நீர் ராசிகள்',
      waterDesc: 'கடகம், விருச்சிகம், மீனம்',
      waterTrait: 'உணர்ச்சிகரமான, உள்ளுணர்வு, மர்மமான',
    },

    // Hindu Festivals
    hinduFestivals: {
      title: 'இந்து பண்டிகைகள்',
      subtitle: 'இந்து பண்டிகைகள், விரதங்கள் மற்றும் சுப தேதிகளின் முழுமையான மாதவாரி நாட்காட்டி',
      searchPlaceholder: 'பண்டிகைகளைத் தேடுங்கள்...',
      showing: 'காட்டுகிறது',
      festival: 'பண்டிகை',
      festivals: 'பண்டிகைகள்',
      all: 'அனைத்தும்',
      major: 'முக்கிய',
      ekadashi: 'ஏகாதசி',
      vrat: 'விரதம்',
      purnima: 'பூர்ணிமா',
      amavasya: 'அமாவாசை',
      festivalType: 'பண்டிகை',
      special: 'சிறப்பு',
      keyHighlights: 'முக்கிய சிறப்பம்சங்கள்',
      hinduNewYear: 'இந்து புத்தாண்டு',
      adhikMaas: 'அதிக மாதம்',
      diwali: 'தீபாவளி',
      holi: 'ஹோலி',
      noResults: 'உங்கள் தேடலுக்கு பொருந்தும் பண்டிகைகள் இல்லை.',
    },

    // Contact
    contact: {
      title: 'எங்களை தொடர்பு கொள்ளுங்கள்',
      subtitle: 'கேள்விகள் உள்ளதா? உங்களிடமிருந்து கேட்க விரும்புகிறோம். எங்களுக்கு ஒரு செய்தி அனுப்புங்கள், விரைவில் பதிலளிப்போம்.',
      sendMessage: 'எங்களுக்கு செய்தி அனுப்புங்கள்',
      thankYou: 'உங்கள் செய்திக்கு நன்றி! விரைவில் உங்களை தொடர்பு கொள்வோம்.',
      fullName: 'முழு பெயர்',
      namePlaceholder: 'உங்கள் பெயர்',
      email: 'மின்னஞ்சல் முகவரி',
      emailPlaceholder: 'your@email.com',
      subject: 'பொருள்',
      selectTopic: 'ஒரு தலைப்பைத் தேர்ந்தெடுக்கவும்',
      generalInquiry: 'பொதுவான விசாரணை',
      technicalSupport: 'தொழில்நுட்ப ஆதரவு',
      billingIssue: 'பில்லிங் சிக்கல்',
      feedback: 'கருத்து',
      message: 'செய்தி',
      messagePlaceholder: 'நாங்கள் எப்படி உதவ முடியும்?',
      send: 'செய்தி அனுப்பு',
      liveChat: 'நேரடி அரட்டை',
      liveChatDesc: 'வணிக நேரங்களில் விரைவான பதில்',
      startChat: 'அரட்டை தொடங்கு',
      supportHours: 'ஆதரவு நேரங்கள்: பிரீமியம் உறுப்பினர்களுக்கு 24/7',
      faq: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
    },

    // Cookie Consent
    cookie: {
      title: 'உங்கள் தனியுரிமையை மதிக்கிறோம்',
      description: 'உங்கள் உலாவல் அனுபவத்தை மேம்படுத்தவும், தள போக்குவரத்தை பகுப்பாய்வு செய்யவும், உள்ளடக்கத்தை தனிப்பயனாக்கவும் குக்கீகளைப் பயன்படுத்துகிறோம்.',
      privacyPolicy: 'தனியுரிமைக் கொள்கை',
      hideDetails: 'விவரங்களை மறை',
      cookieDetails: 'குக்கீ விவரங்கள்',
      essential: 'அத்தியாவசிய',
      essentialDesc: 'தளம் செயல்பட தேவை. முடக்க இயலாது.',
      alwaysOn: 'எப்போதும் இயக்கத்தில்',
      analytics: 'பகுப்பாய்வு',
      analyticsDesc: 'பார்வையாளர்கள் தளத்தை எவ்வாறு பயன்படுத்துகிறார்கள் என்பதைப் புரிந்துகொள்ள உதவுகிறது.',
      optional: 'விருப்பமான',
      advertising: 'விளம்பரம்',
      advertisingDesc: 'தொடர்புடைய விளம்பரங்களைக் காட்டப் பயன்படுகிறது.',
      essentialOnly: 'அத்தியாவசியம் மட்டும்',
      acceptAll: 'அனைத்தையும் ஏற்கவும்',
    },

    // Tamil Festivals
    tamilFestivals: {
      title: 'தமிழ் பண்டிகைகள்',
      subtitle: 'தமிழ் மாதம் வாரியாக தமிழ்நாடு பண்டிகைகள், விரதங்கள் மற்றும் சுப தேதிகளின் முழுமையான நாட்காட்டி',
      searchPlaceholder: 'தமிழ் பண்டிகைகளைத் தேடுங்கள்...',
      showing: 'காட்டுகிறது',
      festival: 'பண்டிகை',
      festivals: 'பண்டிகைகள்',
      all: 'அனைத்தும்',
      major: 'முக்கிய',
      pongal: 'பொங்கல்',
      vrat: 'விரதம்',
      pournami: 'பௌர்ணமி',
      amavasai: 'அமாவாசை',
      festivalType: 'பண்டிகை',
      noResults: 'உங்கள் தேடலுக்கு பொருந்தும் பண்டிகைகள் இல்லை.',
      keyHighlights: 'முக்கிய தமிழ் பண்டிகைகள்',
      thaiPongal: 'தைப்பொங்கல்',
      tamilNewYear: 'தமிழ் புத்தாண்டு',
      deepavali: 'தீபாவளி',
      karthigaiDeepam: 'கார்த்திகை தீபம்',
      pongalBanner: 'பிரமாண்டமான 4 நாள் தமிழ் அறுவடைத் திருவிழா ஜனவரி 13 அன்று போகி பண்டிகையுடன் தொடங்கி ஜனவரி 16 அன்று காணும் பொங்கலுடன் நிறைவடைகிறது. தைப்பொங்கல் (ஜனவரி 14) சூரிய பகவானுக்கு அர்ப்பணிக்கப்பட்ட முக்கிய கொண்டாட்ட நாள்.',
    },

    // Telugu Festivals
    teluguFestivals: {
      title: 'தெலுங்கு பண்டிகைகள்',
      subtitle: 'ஆந்திர பிரதேசம் & தெலங்கானா பண்டிகைகள், விரதங்கள் மற்றும் சுப தேதிகளின் முழுமையான நாட்காட்டி',
      searchPlaceholder: 'தெலுங்கு பண்டிகைகளைத் தேடுங்கள்...',
      showing: 'காட்டுகிறது',
      festival: 'பண்டிகை',
      festivals: 'பண்டிகைகள்',
      all: 'அனைத்தும்',
      major: 'முக்கிய',
      ekadashi: 'ஏகாதசி',
      vrat: 'விரதம்',
      purnima: 'பூர்ணிமா',
      amavasya: 'அமாவாசை',
      festivalType: 'பண்டிகை',
      special: 'சிறப்பு',
      noResults: 'உங்கள் தேடலுக்கு பொருந்தும் பண்டிகைகள் இல்லை.',
      keyHighlights: 'முக்கிய தெலுங்கு பண்டிகைகள்',
      sankranti: 'மகர சங்கராந்தி',
      ugadi: 'உகாதி',
      deepavali: 'தீபாவளி',
      vinayakaChavithi: 'விநாயக சவுதி',
      ugadiBanner: 'தெலுங்கு புத்தாண்டு புதிய சைத்ர மாதத்தின் தொடக்கத்தைக் குறிக்கிறது. உகாதி பச்சடி (ஆறு சுவை உணவு), பஞ்சாங்க ஸ்ரவணம் மற்றும் புதிய தொடக்கங்களுடன் ஆந்திர பிரதேசம் மற்றும் தெலங்கானா முழுவதும் கொண்டாடப்படுகிறது.',
    },

    // Blog
    blog: {
      title: 'ஜோதிடம் & பஞ்சாங்கம்',
      titleHighlight: 'கட்டுரைகள்',
      subtitle: 'எங்கள் நிபுணர் வேத ஜோதிடர்களின் நுண்ணறிவுகள், வழிகாட்டிகள் மற்றும் பிரபஞ்ச ஞானத்தை ஆராயுங்கள்',
      searchPlaceholder: 'கட்டுரைகளைத் தேடுங்கள்...',
      allPosts: 'அனைத்து கட்டுரைகள்',
      featured: 'சிறப்பு',
      readArticle: 'கட்டுரையைப் படிக்கவும்',
      readMore: 'மேலும் படிக்கவும் →',
      noResults: 'உங்கள் தேடலுக்கு பொருந்தும் கட்டுரைகள் இல்லை.',
      newsletter: 'பிரபஞ்ச நுண்ணறிவுகளுடன் புதுப்பித்த நிலையில் இருங்கள்',
      newsletterDesc: 'சமீபத்திய ஜோதிட கட்டுரைகள் மற்றும் கணிப்புகளுக்கு எங்கள் செய்திமடலுக்கு பதிவு செய்யுங்கள்',
      subscribe: 'பதிவு செய்',
      emailPlaceholder: 'உங்கள் மின்னஞ்சலை உள்ளிடவும்',
    },

    // Common
    common: {
      explore: 'ஆராயுங்கள்',
      readMore: 'மேலும் படிக்கவும்',
      viewAll: 'அனைத்தையும் காண்க',
      learnMore: 'மேலும் அறிக',
      submit: 'சமர்ப்பிக்கவும்',
      loading: 'ஏற்றுகிறது...',
      error: 'ஏதோ தவறு ஏற்பட்டது',
      noData: 'தரவு கிடைக்கவில்லை',
    },

    // Months
    months: {
      January: 'ஜனவரி',
      February: 'பிப்ரவரி',
      March: 'மார்ச்',
      April: 'ஏப்ரல்',
      May: 'மே',
      June: 'ஜூன்',
      July: 'ஜூலை',
      August: 'ஆகஸ்ட்',
      September: 'செப்டம்பர்',
      October: 'அக்டோபர்',
      November: 'நவம்பர்',
      December: 'டிசம்பர்',
    },
  },
};
